module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/4/4-078057cbbc785caf483b13f628d71654.jpg";